// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_shipping_title = /** @type {(inputs: {}) => string} */ () => {
	return `Shipping & Delivery`
};

const el_shipping_title = /** @type {(inputs: {}) => string} */ () => {
	return `Αποστολή & Παράδοση`
};

const ru_shipping_title = /** @type {(inputs: {}) => string} */ () => {
	return `Доставка`
};

const he_shipping_title = /** @type {(inputs: {}) => string} */ () => {
	return `משלוח ואספקה`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping_title", locale)
	if (locale === "en") return en_shipping_title(inputs)
	if (locale === "el") return el_shipping_title(inputs)
	if (locale === "ru") return ru_shipping_title(inputs)
	if (locale === "he") return he_shipping_title(inputs)
	return "shipping_title"
};